// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form__submit {
  font-family: "Jost", sans-serif;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.01em;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.login-form__container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 11px;
}
@media screen and (min-width: 1025px) {
  .login-form__container {
    margin-top: 30px;
  }
}
.login-form__error {
  font-family: "Jost", sans-serif;
  letter-spacing: 0.04em;
  font-size: 12px;
  line-height: 18px;
  color: #ed4848;
  height: 18px;
  transition: opacity 0.25s;
}
.login-form__error.hidden {
  pointer-events: none;
  opacity: 0;
}
.login-form__input {
  width: 100%;
  margin-top: 34px;
}
.login-form__input:first-of-type {
  margin-top: 15px;
}
@media screen and (min-width: 1025px) {
  .login-form__input {
    max-width: 265px;
  }
}
.login-form__submit {
  margin-top: 34px;
}
@media screen and (min-width: 1025px) {
  .login-form__submit {
    max-width: 265px;
  }
}`, "",{"version":3,"sources":["webpack://./src/common.scss","webpack://./src/components/Login/Login.scss"],"names":[],"mappings":"AAqBA;EACE,+BApBe;EAqBf,eAAA;EACA,iBAAA;EACA,sBAAA;ACpBF;;ADqCA;EACE;IACE,uBAAA;EClCF;EDoCA;IACE,yBAAA;EClCF;AACF;AAXE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;AAaJ;AAXI;EAPF;IAQI,gBAAA;EAcJ;AACF;AAXE;EACE,+BDda;ECeb,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cDTU;ECUV,YAAA;EACA,yBAAA;AAaJ;AAXI;EACE,oBAAA;EACA,UAAA;AAaN;AATE;EACE,WAAA;EACA,gBAAA;AAWJ;AATI;EACE,gBAAA;AAWN;AARI;EARF;IASI,gBAAA;EAWJ;AACF;AARE;EAEE,gBAAA;AASJ;AAPI;EAJF;IAKI,gBAAA;EAUJ;AACF","sourcesContent":["// Fonts\n$font-primary: 'Jost', sans-serif;\n$font-secondary: 'Jost', sans-serif;\n\n// Colors\n$color-primary: #0f0f0f;\n$color-secondary: #ffffff;\n$light-gray: #f0f0f0;\n$gray: #bdbdbd;\n$medium-gray: #8c8c8c;\n$dark-gray: #545454;\n$color-alert: #ed4848;\n\n// Placeholders\n%body-s {\n  font-family: $font-secondary;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.04em;\n}\n\n%body-m {\n  font-family: $font-secondary;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0.01em;\n}\n\n%body-l {\n  font-family: $font-secondary;\n  font-size: 18px;\n  line-height: 26px;\n  letter-spacing: 0.01em;\n}\n\n// Animations\n$speed-smooth: 1s;\n$speed-slow: 0.65s;\n$speed-medium: 0.35s;\n$speed-fast: 0.25s;\n$speed-very-fast: 0.15s;\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n","@import \"../../common.scss\";\n\n.login-form {\n  &__container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin-top: 11px;\n\n    @media screen and (min-width: 1025px) {\n      margin-top: 30px;\n    }\n  }\n\n  &__error {\n    font-family: $font-secondary;\n    letter-spacing: 0.04em;\n    font-size: 12px;\n    line-height: 18px;\n    color: $color-alert;\n    height: 18px;\n    transition: opacity $speed-fast;\n\n    &.hidden {\n      pointer-events: none;\n      opacity: 0;\n    }\n  }\n\n  &__input {\n    width: 100%;\n    margin-top: 34px;\n\n    &:first-of-type {\n      margin-top: 15px;\n    }\n\n    @media screen and (min-width: 1025px) {\n      max-width: 265px;\n    }\n  }\n\n  &__submit {\n    @extend %body-m;\n    margin-top: 34px;\n\n    @media screen and (min-width: 1025px) {\n      max-width: 265px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
